import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

import leftImage from "./trackculture.jpg"; // replace with port/ship image
import img1 from "./barrer.jpg"; // shipping
import img2 from "./barrerrr.jpg"; // cargo
import img3 from "./barrer.jpg"; // warehouse
import img4 from "./barrerrr.jpg"; // delivery

import "./HomeSlide.css";

const HomeSlide = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <section className="image-section">

      {/* LEFT - COMPANY INTRO */}
      <div className="left-image" data-aos="fade-right">
        <img src={leftImage} alt="Zuluwhiskey Shipping" />

        <div className="left-overlay">
          <h2>Zuluwhiskey Shipping Company</h2>
          <p>
            We provide reliable international shipping, cargo handling, and logistics
            solutions. Trusted for speed, safety, and efficiency across borders.
          </p>
        </div>
      </div>

      {/* RIGHT - SERVICES */}
      <div className="right-grid">

        {/* SERVICE 1 */}
        <div className="image-card" data-aos="fade-up">
          <img src={img1} alt="Shipping" />
          <div>
            <h3>Global Shipping</h3>
            <p>
              Fast and secure delivery of goods worldwide with real-time tracking.
            </p>
          </div>
        </div>

        {/* SERVICE 2 */}
        <div className="image-card" data-aos="fade-up" data-aos-delay="200">
          <img src={img2} alt="Cargo" />
          <div>
            <h3>Heavy Cargo</h3>
            <p>
              Transport of bulk materials, machinery, and construction equipment.
            </p>
          </div>
        </div>

        {/* SERVICE 3 */}
        <div className="image-card" data-aos="fade-up" data-aos-delay="400">
          <img src={img3} alt="Warehouse" />
          <div>
            <h3>Warehousing</h3>
            <p>
              Safe storage facilities with organized logistics and inventory handling.
            </p>
          </div>
        </div>

        {/* SERVICE 4 */}
        <div className="image-card" data-aos="fade-up" data-aos-delay="600">
          <img src={img4} alt="Delivery" />
          <div>
            <h3>Doorstep Delivery</h3>
            <p>
              Reliable last-mile delivery ensuring your goods reach safely on time.
            </p>
          </div>
        </div>

      </div>

    </section>
  );
};

export default HomeSlide;